import Footer from "../components/Footer";
import Navbar from "../components/SpectraNavbar";
import "../styles/styles.css"; // Import the CSS file

const Terms = () => {
  return (
    <div className='flex-container terms-page'>
      <Navbar signedIn={false} />
      <div className='flex-body mx-5'>
        <div className='full-height terms-body-inner'>
          <div className='px-sm-3 px-lg-5 py-3 full-height terms-content-wrap'>
            <div className='row terms-content-row'>
              <div className='col-4 terms-nav-column'>
                <nav
                  id='navbar-example3'
                  className='h-100 flex-column align-items-stretch pe-3 border-end terms-nav-outer'
                >
                  <nav className='nav nav-pills flex-column terms-nav-scroll'>
                    <details className='terms-nav-group'>
                      <summary className='terms-nav-summary fs-5'>
                        Web Application Disclaimer
                      </summary>
                      <nav className='nav nav-pills flex-column ms-3'>
                        <a className='nav-link my-1' href='#web-app-disclaimer'>
                          Overview
                        </a>
                        <a className='nav-link my-1' href='#web-app-content'>
                          1. Content
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#product-drug-analysis'
                        >
                          2. Use of Product for Drug Analysis
                        </a>
                      </nav>
                    </details>
                    <div className='border-top my-3'></div>
                    <details className='terms-nav-group'>
                      <summary className='terms-nav-summary fs-5'>
                        Drug Analyzer Terms and Conditions of Sale
                      </summary>
                      <nav className='nav nav-pills flex-column ms-3'>
                        <a className='nav-link my-1' href='#drug-analyzer'>
                          Overview
                        </a>
                        <a className='nav-link my-1' href='#definitions'>
                          1. Definitions
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#ordering-and-quotes'
                        >
                          2. Ordering and Quotes
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#acceptance-of-orders'
                        >
                          3. Acceptance of Orders
                        </a>
                        <a className='nav-link my-1' href='#payment'>
                          4. Payment; Purchase Price and Associated Charges
                        </a>
                        <a className='nav-link my-1' href='#price-changes'>
                          5. Price Changes
                        </a>
                        <a className='nav-link my-1' href='#title-and-risk'>
                          6. Title; Risk of Loss
                        </a>
                        <a className='nav-link my-1' href='#limited-warranty'>
                          7. Limited Warranty
                        </a>
                        <a className='nav-link my-1' href='#technical-support'>
                          8. Technical Support
                        </a>
                        <a className='nav-link my-1' href='#reachback-support'>
                          9. Reachback Support
                        </a>
                        <a className='nav-link my-1' href='#data-ownership'>
                          10. Data Ownership
                        </a>
                        <a className='nav-link my-1' href='#suggestions'>
                          11. Suggestions
                        </a>
                        <a className='nav-link my-1' href='#repair'>
                          12. Repair
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#limitation-of-liability'
                        >
                          13. Limitation of Liability
                        </a>
                        <a className='nav-link my-1' href='#indemnification'>
                          14. Indemnification
                        </a>
                        <a className='nav-link my-1' href='#software-licenses'>
                          15. Software Licenses
                        </a>
                        <a className='nav-link my-1' href='#disclaimer'>
                          16. Disclaimer
                        </a>
                        <a className='nav-link my-1' href='#general'>
                          17. General
                        </a>
                      </nav>
                    </details>
                    <div className='border-top my-3'></div>
                    <details className='terms-nav-group'>
                      <summary className='terms-nav-summary fs-5'>
                        Software License Agreement - Connector Application
                      </summary>
                      <nav className='nav nav-pills flex-column ms-3'>
                        <a
                          className='nav-link my-1'
                          href='#software-license-agreement'
                        >
                          Overview
                        </a>
                        <a className='nav-link my-1' href='#license-grant'>
                          1. Grant of License
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#license-restrictions'
                        >
                          2. License Restrictions
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#intellectual-property-rights'
                        >
                          3. Intellectual Property rights
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#updates-and-support'
                        >
                          4. Updates and Support
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#data-privacy-security'
                        >
                          5. Data Privacy and Security
                        </a>
                        <a
                          className='nav-link my-1'
                          href='#limitations-of-liability'
                        >
                          6. Limitations of Liability
                        </a>
                        <a className='nav-link my-1' href='#termination'>
                          7. Termination
                        </a>
                        <a className='nav-link my-1' href='#export-control'>
                          8. Export Control
                        </a>
                        <a className='nav-link my-1' href='#governing-law'>
                          9. Governing Law
                        </a>
                        <a className='nav-link my-1' href='#acceptance'>
                          10. Acceptance
                        </a>
                      </nav>
                    </details>
                  </nav>
                </nav>
              </div>

              <div className='col-8 terms-content-column'>
                <div>
                  <h1 className='text-center'>Terms and Conditions</h1>
                  <div id='web-app-disclaimer'>
                    <h2>Web Application Disclaimer</h2>
                  </div>
                  <div id='web-app-content'>
                    <h3>1. Content</h3>
                    <p>
                      The contents of this Spectra Plasmonics (“<b>Spectra</b>”)
                      web application (app.spectraplasmonics.com, “
                      <b>Web App</b>”), such as text, graphics, Raman spectra,
                      and other materials contained on the Web App (“
                      <b>Content</b>”), are for informational purposes only. The
                      Content is not intended to be a substitute for
                      professional medical advice, diagnosis, or treatment, and
                      the Content is not intended to provide legal or regulatory
                      advice.
                    </p>
                  </div>
                  <div id='product-drug-analysis'>
                    <h3>2. Use of Product for Drug Analysis</h3>
                    <p>
                      The Amplifi ID Raman Spectrometer, Web App, and associated
                      attachments and accessories (the “<b>Product</b>”) is
                      provided to assist in the analysis of the components of
                      suspected illicit drugs in facilities such as supervised
                      injection sites, public health sites, or similar, and by
                      law enforcement personnel. Spectra does not supply or
                      otherwise make available any illegal or prohibited
                      substances. The Product is provided to assist suitably
                      qualified and experienced staff to detect dangerous
                      components, compounds or materials within suspected
                      illicit drugs, but no representation or warranty is made
                      that all or any such dangerous components, compounds or
                      materials will be detected. Further, it is the nature of
                      illicit and illegal substances that they pose a threat to
                      the health and wellbeing of any individual who takes such
                      substances. Spectra in no way guarantees that any
                      substance is safe to use. No representation or warranty is
                      given that any person who takes a substance that was
                      screened using the Product will not suffer an adverse
                      consequence notwithstanding any result or lack of results
                      produced by the Product, including without limitation the
                      lack of any warning or warning indicator. Any person
                      taking, injecting or otherwise using any illicit or
                      illegal substance does so entirely at their own risk.
                    </p>
                    <p>
                      Additionally, Spectra makes no representations and
                      provides no warranties or conditions of any kind, whether
                      express, implied, statutory or otherwise, and specifically
                      disclaims all implied representations, warranties and/or
                      conditions, including any representations, warranties
                      and/or conditions of merchantability, merchantable
                      quality, durability, title, non-infringement, satisfactory
                      quality or fitness for a particular purpose, to the
                      maximum extent permitted by applicable law. Without
                      limiting the above, Spectra does not make any
                      representation or warranty in respect of any result,
                      analyses or output generated by the Product, including in
                      particular but without limitation that all or any
                      dangerous components, compounds or materials will be
                      detected. Further, it is the nature of illicit and illegal
                      substances that they pose a threat to the health and
                      wellbeing of any individual who takes such substances. No
                      representation or warranty is given that any person who
                      takes a substance that was screened using the Product will
                      not suffer an adverse consequence notwithstanding any
                      result or lack of results produced by the Product,
                      including without limitation the lack of any warning or
                      warning indicator. Any person taking, injecting or
                      otherwise using any illicit or illegal substance does so
                      entirely at their own risk the disclaimer set out above.
                    </p>
                  </div>
                  <div
                    className='border-top border-2 my-5 mx-5 '
                    style={{ "--bs-border-color": "#f08021" }}
                  ></div>
                  <div id='drug-analyzer'>
                    <h2>Drug Analyzer Terms and Conditions of Sale</h2>
                  </div>
                  <div id='definitions'>
                    <h3>1. Definitions</h3>
                    <p>
                      The following terms shall have the following meanings:
                    </p>

                    <p>
                      1.1 <strong>"Spectra Software"</strong> means the software
                      applications developed by Spectra and used in connection
                      with certain Spectra products;
                    </p>
                    <p>
                      1.2 <strong>"Web App"</strong> means the web application
                      used to facilitate use of the Product;
                    </p>
                    <p>
                      1.3 <strong>"Service Data"</strong> means all data
                      uploaded or transmitted to the Web App by Customer or on
                      Customer’s behalf, including data from any Spectra
                      product, as well as any data that is derived from such
                      data;
                    </p>
                    <p>
                      1.4 <strong>"Reachback"</strong> means remote testing
                      result support that can be provided by Spectra to assist
                      Customer in correctly identifying analytically challenging
                      samples.
                    </p>
                  </div>
                  <div id='ordering-and-quotes'>
                    <h3>2. Ordering and Quotes</h3>
                    <p>
                      Specific quantities of Product(s) may be ordered by
                      Customer by submitting orders to Spectra. Each order shall
                      include: (i) unit quantity; (ii) shipping destination;
                      (iii) delivery date, and (iv) any other instructions or
                      requirements pertinent to the order. While Spectra uses
                      reasonable commercial endeavors to deliver the Product in
                      a timely manner, supply of Test Kits and Hardware is
                      subject to third party component availability and
                      third-party delivery providers, and accordingly, Spectra
                      cannot guarantee availability or delivery times. Spectra
                      claims no right of ownership to and disclaims any and all
                      responsibility for any Product.{" "}
                    </p>
                  </div>
                  <div id='acceptance-of-orders'>
                    <h3>3. Acceptance of Orders</h3>
                    <p>
                      An order shall be deemed to have been placed by Customer
                      as of the date of receipt of such order by Spectra. If
                      Customer submits an order, such order shall not be binding
                      on Spectra and no obligation to supply Product(s) shall be
                      imposed on Spectra until it is accepted by Spectra in
                      writing. Spectra will use commercially reasonable efforts
                      to respond to each order submitted by Customer within ten
                      (10) business days following receipt thereof; if Spectra
                      does not respond in writing within such time, then such
                      order shall be deemed to have been rejected in writing by
                      Spectra. Spectra shall not be obliged to fulfill accepted
                      purchase orders for Product(s) if Customer is in default
                      of any of Customer’s obligations under these Sale Terms
                      and Spectra shall have the right, without limitation, to
                      withhold shipment or to stop shipments of Product(s).
                      Customer may not cancel an order once it has been accepted
                      by Spectra.
                    </p>
                  </div>
                  <div id='payment'>
                    <h3>4. Payment; Purchase Price and Associated Charges</h3>
                    <p>
                      Payment must be made at the time Customer submits
                      Customer’s order unless otherwise agreed by Spectra in
                      writing. Spectra is under no obligation to extend credit
                      arrangements to Customer. Customer will pay the total
                      purchase price for each order plus shipping and handling,
                      if any, as specified in the emailed invoice. Customer is
                      also responsible for all taxes related to any purchase and
                      for any duties or other fees for the import of the
                      Product(s), if applicable, including but not limited to
                      all sales taxes, value-added taxes, import
                      taxes/customs/duties, and any other similar taxes or fees
                      imposed by any governmental entity. For Canadian sales,
                      Spectra will invoice Customer for the applicable
                      sales-related taxes and subject to Customer’s payment of
                      such taxes will submit such amounts to the applicable
                      Canadian taxation authority.  For non-Canadian sales,
                      Customer shall be responsible for paying and submitting
                      all sales taxes, value-added taxes, import
                      taxes/customs/duties, and any other similar taxes or fees
                      imposed by any applicable taxation authority. If any
                      payment, or any other sum due to Spectra under these Sale
                      Terms becomes past due for more than thirty (30) days,
                      Spectra may charge Customer a late payment charge of one
                      percent (1%) per month (12.67% annually) or the maximum
                      rate legally permitted, whichever is less, commencing from
                      the date the payment first became overdue.{" "}
                    </p>
                  </div>
                  <div id='price-changes'>
                    <h3>5. Price Changes</h3>
                    <p>
                      {" "}
                      Spectra may change, in its sole discretion, any pricing
                      set forth in its price lists at any time. If Spectra
                      increases the price of a Product, all orders for such
                      Product accepted prior to the effective date of the price
                      increase shall be invoiced at the previous price. Spectra
                      may discontinue offering any Product at any time.{" "}
                    </p>
                  </div>
                  <div id='title-and-risk'>
                    <h3>6. Title; Risk of Loss</h3>
                    <p>
                      Title to ordered Product(s) (other than any software
                      and/or firmware embodied therein) passes to Customer when
                      these Product(s) are provided by Spectra to the common
                      carrier selected to ship the Product(s) to Customer.
                      Customer is responsible for all fees and shipping costs
                      associated with the Products. Customer bears all
                      responsibility for loss of or damage to purchased
                      Product(s) during initial shipment after purchase and
                      until such Product(s) are received by Customer. The
                      Product may be subject to additional license or other
                      terms and conditions, as required by the manufacturer,
                      developer or supplier of the Hardware and any software
                      that may be installed on the Product (“
                      <strong>Third Party Terms</strong>”). Spectra is not a
                      party to such terms. Unless otherwise specified in the
                      applicable Order Form, Customer shall be responsible for
                      the installation of the Product in accordance with the
                      installation guide provided by the applicable third-party
                      provider which may be subject to additional Third Party
                      Terms. For Product(s) being returned for repair, risk of
                      loss is borne by Customer for return shipment of the
                      Product to Spectra and by Spectra following repair and
                      upon shipment to Customer.
                    </p>
                  </div>
                  <div id='limited-warranty'>
                    <h3>7. Limited Warranty</h3>
                    <p>
                      Spectra warrants purchased Product(s) against defects in
                      materials and workmanship under normal use that includes
                      factory repair, loaner units when available and technical
                      support (the “<strong>Warranty</strong>”) for a period of
                      twelve (12) months from the date which the Products are
                      shipped by Spectra (the “<strong>Warranty Period</strong>
                      ”) subject to the condition that Customer has completely
                      paid for the applicable Product(s). Spectra does not
                      warrant that the operation of the Product(s) will be
                      uninterrupted or error-free. Unless otherwise required by
                      applicable law, the Warranty Period does not restart if
                      Customer receives a replacement Product pursuant to the
                      Warranty. The Warranty does not apply to: (a) consumable
                      parts, such as batteries, unless the relevant damage has
                      occurred due to a defect in materials or workmanship; (b)
                      accessory parts such as a laptop or computer provided by
                      Spectra, to be used to operate the Product; (c) cosmetic
                      damage, including scratches, dents and broken plastic on
                      ports; (d) damage caused by accident, abuse, misuse,
                      neglect or failure to properly maintain (including water
                      damage and/or condensation or improper temperatures during
                      storage), or improper installation or use or any attempted
                      repair or modification by anyone other than as authorized
                      by Spectra; (e) damage caused by electrical disturbances
                      or acts of God (including, civil disturbance, war,
                      terrorism, flood, fire, rodents or insects); (f)
                      situations where manufacturer’s serial numbers and/or
                      security labels have been removed from applicable
                      Product(s); and (g) damage caused during shipment (due to
                      Customer’s improper packaging) from Customer to Spectra in
                      the case of Product returns for repair. Customer may
                      extend the Warranty Period by providing Spectra with at
                      least twenty (20) business days notice before termination
                      of the then current Warranty Period and pays the
                      applicable fee.
                    </p>
                    <p>
                      Except for the Warranty, Spectra disclaims all other
                      representations, warranties and conditions, express or
                      implied, including any implied warranties and/or
                      conditions of merchantability, merchantable quality,
                      non-infringement, fitness for a particular purpose, or
                      against hidden or latent defects. Spectra’s responsibility
                      for claims in respect to the operation of purchased
                      Product(s) is limited to the repair or replacement of
                      Product(s) under the Warranty that are within their
                      applicable Warranty Period.
                    </p>
                  </div>
                  <div id='technical-support'>
                    <h3>8. Technical Support</h3>
                    <p>
                      Spectra will provide technical support to Customer in
                      accordance with Spectra’s then-current support policy and
                      in accordance with the Warranty set forth in these Sale
                      Terms, unless full payment for the applicable Product(s)
                      has not been received. Spectra will respond to Customer
                      support problems by phone or by email. If a support
                      problem cannot be rectified via phone or email, Customer
                      will be provided with return instructions for the affected
                      Product.
                    </p>
                  </div>
                  <div id='reachback-support'>
                    <h3>9. Reachback Support</h3>
                    <p>
                      Spectra will provide Reachback support to Customer in
                      accordance with Spectra’s then-current Reachback support
                      policy. Reachback support is provided during the initial
                      twelve (12) month Warranty Period (“
                      <strong>Reachback Period</strong>”). Customer may extend
                      the Reachback Period by providing Spectra with at least
                      twenty (20) business days notice before termination of the
                      then current Reachback Period and pays the applicable fee.
                      Spectra will respond to Customer for Reachback requests
                      via the Web App or by email.
                    </p>
                  </div>
                  <div id='data-ownership'>
                    <h3>10. Data Ownership</h3>
                    <p>
                      Spectra shall own all right, title and interest (including
                      all intellectual property rights) in and to the Service
                      Data. If any rights in any Service Data initially vest in
                      Customer, Customer hereby assigns, transfers and conveys
                      to Spectra all of Customer’s right, title and interest
                      (including all intellectual property rights) in and to
                      such Service Data.  Spectra will be entitled to make
                      Service Data available to third parties in Spectra’s
                      discretion if such Service Data does not identify Customer
                      and cannot be traced back to Customer. For greater
                      certainty, Spectra shall own all right, title and interest
                      (including all intellectual property rights) in and to any
                      analytics created therefrom and shall be entitled to use
                      the said analytics without any requirement for Customer’s
                      permission provided that the analytics do not identify
                      Customer and cannot be traced back to Customer.
                    </p>
                  </div>
                  <div id='suggestions'>
                    <h3>11. Suggestions</h3>
                    <p>
                      If You provide Spectra with any suggestions, comments or
                      other feedback relating to any aspect of the Products, the
                      Spectra Software, the Web App or any other Spectra
                      products or services ("<strong>Feedback</strong>"), You
                      hereby grant Spectra a royalty-free, worldwide,
                      transferable, sublicenseable, irrevocable, perpetual,
                      unrestricted license to fully exploit such Feedback,
                      including, within the Products, the Spectra Software, the
                      Web App or any other Spectra products or services.
                    </p>
                  </div>
                  <div id='repair'>
                    <h3>12. Repair</h3>
                    <p>
                      If a Product is damaged or defective upon initial delivery
                      to Customer (the date of delivery is hereinafter referred
                      to as the “<strong>Delivery Date</strong>”), Customer must
                      notify Spectra technical support within thirty (30) days
                      of the Delivery Date to receive a replacement for such
                      Product. Upon receipt of timely notification about any
                      Product that was damaged or defective upon initial
                      delivery to Customer, Spectra will provide return
                      instructions, if required. Product(s) that were damaged or
                      defective upon initial delivery to Customer, must then be
                      returned to Spectra as soon as reasonably practicable for
                      repair or replacement in Spectra’s discretion. Spectra may
                      arrange for the delivery of temporary or permanent
                      replacement Product(s) for Product(s) that were damaged or
                      defective upon initial delivery. If a Product is damaged
                      or defective upon initial delivery to Customer, Spectra
                      may in its discretion provide a refund for the affected
                      Product(s) instead of repairing or replacing the affected
                      Product.
                    </p>
                    <p>
                      If during the Warranty Period, but, following the initial
                      thirty (30) day period, a Product fails to comply with the
                      Warranty, Customer must contact Spectra technical support
                      to confirm the Warranty non-compliance and to obtain
                      return instructions if needed. Customer shall be
                      responsible for properly packing return shipments of all
                      Product(s) to Spectra (for whatever reason) and for
                      shipping and insurance costs for such return shipments. If
                      a Product is returned for repair or replacement at any
                      time following purchase by Customer and Spectra discovers
                      that the Warranty is inapplicable due to a Warranty
                      exclusion, the Product will not be repaired and will be
                      returned to Customer at Customer’s expense, unless
                      Customer authorizes and pays for the applicable repair.
                      Whether Customer authorizes a repair or not, Spectra
                      reserves the right to charge a “No Fault Found” fee if a
                      Product is found not to be defective.
                    </p>
                    <p>
                      Any Spectra reseller or distributor involved in the
                      purchase of a Product is not authorized to make any
                      modification, extension, or addition to the Warranty
                      provided by Spectra pursuant to these Sale Terms, although
                      any such reseller or distributor may provide its own
                      warranty in addition to the Warranty provided by Spectra.
                    </p>
                  </div>
                  <div id='limitation-of-liability'>
                    <h3>13. Limitation of Liability</h3>
                    <p>
                      NEITHER SPECTRA NOR ITS LICENSORS, RESELLERS, DEALERS OR
                      SUPPLIERS SHALL HAVE ANY LIABILITY TO CUSTOMER OR ANY
                      OTHER PERSON OR ENTITY FOR ANY INDIRECT, INCIDENTAL,
                      SPECIAL, CONSEQUENTIAL OR ANY OTHER SIMILAR DAMAGES
                      WHATSOEVER, INCLUDING, BUT NOT LIMITED TO, LOSS OF REVENUE
                      OR PROFIT, LOST OR DAMAGED DATA OR OTHER COMMERCIAL OR
                      ECONOMIC LOSS, EVEN IF SPECTRA HAS BEEN ADVISED OF THE
                      POSSIBILITY OF SUCH DAMAGES, OR THEY ARE FORESEEABLE.
                      SPECTRA IS ALSO NOT RESPONSIBLE FOR CLAIMS BY A THIRD
                      PARTY. THE PRODUCT(S) ARE NOT FAULT-TOLERANT AND ARE NOT
                      DESIGNED, MANUFACTURED, OR INTENDED FOR USE OR RESALE AS
                      PRODUCTS FOR USE IN HAZARDOUS ENVIRONMENTS REQUIRING
                      FAIL-SAFE PERFORMANCE IN WHICH THE FAILURE OF THE
                      PRODUCT(S) COULD LEAD DIRECTLY TO DEATH, PERSONAL INJURY,
                      OR SEVERE PHYSICAL OR ENVIRONMENTAL DAMAGE. SPECTRA’S
                      MAXIMUM AGGREGATE LIABILITY TO CUSTOMER, AND THAT OF
                      SPECTRA’S LICENSORS, DEALERS, RESELLERS AND SUPPLIERS
                      SHALL NOT EXCEED THE PRICE PAID FOR THE PRODUCT(S) GIVING
                      RISE TO THE CLAIM. THE LIMITATIONS IN THIS SECTION SHALL
                      APPLY WHETHER OR NOT THE ALLEGED BREACH OR DEFAULT IS A
                      BREACH OF A FUNDAMENTAL CONDITION OR TERM OR A FUNDAMENTAL
                      BREACH.
                    </p>
                  </div>
                  <div id='indemnification'>
                    <h3>14. Indemnification</h3>
                    <p>
                      You shall, at Your own expense, defend, indemnify and hold
                      harmless Spectra including its affiliated companies and
                      its and their officers, employees and subcontractors
                      (collectively, the “<strong>Spectra Indemnitees</strong>”)
                      against all liabilities, losses, costs, damages, penalties
                      and expenses (including all legal fees and expenses and
                      court costs) which the Spectra Indemnitees may incur or
                      suffer as a result of (i) any bodily injury, death or
                      damage to real or personal property arising in connection
                      with Your or an End User’s products and/or data provided
                      by You or an End User or on Your or an End User’s behalf
                      to the Web App, including Your or an End User’s failure to
                      provide accurate, up date on an on-going basis,; (ii) Your
                      or an End User’s negligence or willful misconduct; (iii)
                      any errors, omissions, inaccuracies or other claims
                      arising in connection with the Products provided by You or
                      an End User or on Your or an End User’s behalf to the
                      Spectra; (iv) any claims that the trademarks, logos, or
                      branding provided by You or an End User to Spectra
                      infringe third party rights; (v) any defects, malfunctions
                      or product liability claims arising in connection with
                      Your or an End User’s products; (vi) any breach of
                      contract in any agreement between You and any End User;
                      (vii) any representation or warranties made by You that
                      extend, expand or modify the representations and
                      warranties made by Spectra in these Sale Terms in respect
                      to the Products; and/or (viii) any breach by Customer of
                      these Sale Terms.
                    </p>
                  </div>
                  <div id='software-licenses'>
                    <h3>15. Software Licenses</h3>
                    <p>
                      Any software or firmware that is embodied in or provided
                      with any Product(s) purchased by a Customer is licensed
                      pursuant to the terms and conditions of the applicable
                      service terms, including the services terms provided by
                      the Hardware manufacturer or an applicable Spectra
                      Software Agreement or Web App Agreement. No rights are
                      granted to Customer pursuant to these Sale Terms for the
                      Spectra Software or the Web App. Customer shall not
                      reproduce, modify, reverse engineer, decompile,
                      disassemble, or create derivative works based upon any
                      software and/or firmware furnished with any of the
                      Product(s).
                    </p>
                  </div>
                  <div id='disclaimer'>
                    <h3>16. Disclaimer</h3>
                    <p>
                      THE PRODUCT IS PROVIDED TO ASSIST IN THE ANALYSIS OF THE
                      COMPONENTS OF ILLICIT DRUGS IN FACILITIES SUCH AS
                      SUPERVISED INJECTION SITES, PUBLIC HEALTH SITES, OR
                      SIMILAR, AND BY LAW ENFORCEMENT PERSONNEL. SPECTRA DOES
                      NOT SUPPLY OR OTHERWISE MAKE AVAILABLE ANY ILLEGAL OR
                      PROHIBITED SUBSTANCES. THE PRODUCT IS PROVIDED TO ASSIST
                      SUITABLY QUALIFIED AND EXPERIENCED STAFF TO DETECT
                      DANGEROUS COMPONENTS, COMPOUNDS OR MATERIALS WITHIN
                      ILLICIT DRUGS, BUT NO REPRESENTATION OR WARRANTY IS MADE
                      THAT ALL OR ANY SUCH DANGEROUS COMPONENTS, COMPOUNDS OR
                      MATERIALS WILL BE DETECTED. FURTHER, IT IS THE NATURE OF
                      ILLICIT AND ILLEGAL SUBSTANCES THAT THEY POSE A THREAT TO
                      THE HEALTH AND WELLBEING OF ANY INDIVIDUAL WHO TAKES SUCH
                      SUBSTANCES. SPECTRA IN NO WAY GUARANTEES THAT ANY
                      SUBSTANCE IS SAFE TO USE. NO REPRESENTATION OR WARRANTY IS
                      GIVEN THAT ANY PERSON WHO TAKES A SUBSTANCE THAT WAS
                      SCREENED USING THE PRODUCT WILL NOT SUFFER AN ADVERSE
                      CONSEQUENCE NOTWITHSTANDING ANY RESULT OR LACK OF RESULTS
                      PRODUCED BY THE HARDWARE, INCLUDING WITHOUT LIMITATION THE
                      LACK OF ANY WARNING OR WARNING INDICATOR. ANY PERSON
                      TAKING, INJECTING OR OTHERWISE USING ANY ILLICIT OR
                      ILLEGAL SUBSTANCE DOES SO ENTIRELY AT THEIR OWN RISK.
                    </p>
                    <p>
                      ADDITIONALLY, SPECTRA MAKES NO REPRESENTATIONS AND
                      PROVIDES NO WARRANTIES OR CONDITIONS OF ANY KIND, WHETHER
                      EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, AND SPECIFICALLY
                      DISCLAIMS ALL IMPLIED REPRESENTATIONS, WARRANTIES AND/OR
                      CONDITIONS, INCLUDING ANY REPRESENTATIONS, WARRANTIES
                      AND/OR CONDITIONS OF MERCHANTABILITY, MERCHANTABLE
                      QUALITY, DURABILITY, TITLE, NON-INFRINGEMENT, SATISFACTORY
                      QUALITY OR FITNESS FOR A PARTICULAR PURPOSE, TO THE
                      MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW. WITHOUT
                      LIMITING THE ABOVE, SPECTRA DOES NOT MAKE ANY
                      REPRESENTATION OR WARRANTY IN RESPECT OF ANY RESULT,
                      ANALYSES OR OUTPUT GENERATED BY THE PRODUCT, INCLUDING IN
                      PARTICULAR BUT WITHOUT LIMITATION THAT ALL OR ANY
                      DANGEROUS COMPONENTS, COMPOUNDS OR MATERIALS WILL BE
                      DETECTED. FURTHER, IT IS THE NATURE OF ILLICIT AND ILLEGAL
                      SUBSTANCES THAT THEY POSE A THREAT TO THE HEALTH AND
                      WELLBEING OF ANY INDIVIDUAL WHO TAKES SUCH SUBSTANCES. NO
                      REPRESENTATION OR WARRANTY IS GIVEN THAT ANY PERSON WHO
                      TAKES A SUBSTANCE THAT WAS SCREENED USING THE SERVICE WILL
                      NOT SUFFER AN ADVERSE CONSEQUENCE NOTWITHSTANDING ANY
                      RESULT OR LACK OF RESULTS PRODUCED BY THE PRODUCT,
                      INCLUDING WITHOUT LIMITATION THE LACK OF ANY WARNING OR
                      WARNING INDICATOR. ANY PERSON TAKING, INJECTING OR
                      OTHERWISE USING ANY ILLICIT OR ILLEGAL SUBSTANCE DOES SO
                      ENTIRELY AT THEIR OWN RISK THE DISCLAIMER SET OUT ABOVE.
                    </p>
                  </div>
                  <div id='general'>
                    <h3>17. General</h3>
                    <p>
                      These Sales Terms may not be changed except by a written
                      agreement with Spectra. Customer may not assign Customer’s
                      rights and/or obligations under these Sale Terms without
                      Spectra’s prior written consent. Spectra may assign
                      Spectra’s rights and/or obligations under these Sale Terms
                      at any time without notice. If any provision of these Sale
                      Terms is held to be unenforceable for any reason, the
                      legality or enforceability of the remaining terms shall
                      not be affected or impaired. The failure of Spectra to act
                      with respect to a breach of these Sale Terms by Customer
                      does not constitute a waiver and shall not limit Spectra's
                      rights with respect to such breach or any subsequent
                      breaches. The Product(s) and related information are
                      subject to the export and import laws and regulations of
                      Canada and the United States and Customer shall comply
                      with all such laws and regulations as well as any other
                      applicable export laws and regulations. Spectra shall not
                      be responsible for its failure to perform to the extent
                      due to unforeseen circumstances or causes beyond its
                      reasonable control. These Sale Terms shall be governed by
                      the laws of the Province of Ontario, Canada and the laws
                      of Canada applicable therein, excluding any choice of law
                      principles. The United Nations Convention on Contracts for
                      the International Sale of Goods, and any legislation
                      implementing such Convention, shall not apply to these
                      Sale Terms. Customer consents and attorns to the exclusive
                      jurisdiction of the Ontario courts and waives trial by
                      jury. If any provision of these Sale Terms is found to be
                      illegal, invalid or unenforceable, such provision shall be
                      deemed severed and the remainder of these Sale Terms shall
                      continue in full force and effect. Customer shall comply
                      with all applicable laws as they relate to these Sale
                      Terms and Customer’s use of the Product(s). The provisions
                      of these Sale Terms which, by their terms, require
                      performance after the termination of these Sale Terms
                      (which shall include all licenses granted to Spectra
                      pursuant to these Sale Terms), or have application to
                      events that may occur after the termination of these Sale
                      Terms, shall survive the termination or expiration of
                      these Sale Terms.
                    </p>
                  </div>
                  <div
                    className='border-top border-2 my-5 mx-5 '
                    style={{ "--bs-border-color": "#f08021" }}
                  ></div>
                  <div id='software-license-agreement'>
                    <h2>Software License Agreement - Connector Application</h2>
                    <p>
                      <strong>Effective Date:</strong> April 30th, 2025.
                      <br />
                      <strong>Licensor:</strong> Spectra Plasmonics Inc. (“
                      <strong>Spectra</strong>”), a corporation organized under
                      the laws of Canada. <br />
                      <strong>Licensee:</strong> End user purchasing the Product
                      and access to the Software (“<strong>Customer</strong>”).
                    </p>
                  </div>
                  <div id='license-grant'>
                    <h3>1. Grant of License</h3>
                    <p>
                      Subject to the terms and conditions of this Agreement, the
                      Licensor hereby grants the Licensee a non-exclusive,
                      non-transferable, worldwide, limited license to install,
                      use, and execute the software product identified below ("
                      <strong>Software</strong>"):{" "}
                    </p>
                    <ul>
                      <li>Software Name: SP Connector App </li>
                      <li>Version: 3.3.0 and above</li>
                    </ul>
                    <p>
                      Licensor may offer its customers hardware products,
                      including but not limited to a Raman spectrometer (“
                      <strong>Hardware</strong>”), and Amplifi ID Test Kits (“
                      <strong>Test Kits</strong>”) and Automatic Vertical Raman
                      Stage (“<strong>AVR</strong>”) designed to be operated in
                      conjunction with the spectrometer (collectively the “
                      <strong>Product</strong>”).{" "}
                    </p>
                    <p>
                      The Software may only be used for its intended purpose:
                      analyzing Raman spectrometer measurement data collected
                      via Licensor Product(s) and transferring the measurement
                      data to the Licensor’s web application (“
                      <strong>Web App</strong>”).{" "}
                    </p>
                  </div>
                  <div id='license-restrictions'>
                    <h3>2. License Restrictions</h3>
                    <p>The Licensee agrees not to: </p>
                    <ol type='a'>
                      <li>
                        Copy, modify, create derivative works of, or reverse
                        engineer the Software.
                      </li>
                      <li>
                        Rent, lease, sublicense, distribute, or transfer the
                        Software to any third party.
                      </li>
                      <li>
                        Remove, alter, or obscure any copyright, trademark, or
                        other proprietary notices on the Software.
                      </li>
                      <li>
                        Use the Software in any manner that infringes upon the
                        intellectual property rights of the Licensor or any
                        third party.
                      </li>
                    </ol>
                  </div>
                  <div id='intellectual-property-rights'>
                    <h3>3. Intellectual Property rights</h3>
                    <p>
                      The Licensor retains all rights, title, and interest in
                      and to the Software, including all intellectual property
                      rights. The Licensee acknowledges that it acquires no
                      ownership interest in the Software under this
                      Agreement.{" "}
                    </p>
                  </div>
                  <div id='updates-and-support'>
                    <h3>4. Updates and Support</h3>
                    <p>
                      Software updates will be provided at the discretion of the
                      Licensor and made available through the Web App or direct
                      communication. Updates may include performance
                      improvements, bug fixes, and feature enhancements
                    </p>
                  </div>
                  <div id='data-privacy-security'>
                    <h3>5. Data Privacy and Security</h3>
                    <p>
                      Licensor and Licensee shall comply with all applicable
                      data protection and privacy laws. All data uploaded or
                      transmitted to the Web App by Customer or on Customer’s
                      behalf, including data from any Spectra Product, as well
                      as any data that is derived from such data, shall
                      constitute “<strong>Service Data</strong>”. Spectra shall
                      own all right, title and interest (including all
                      intellectual property rights) in and to the Service Data.
                      If any rights in any Service Data initially vest in
                      Customer, Customer hereby assigns, transfers and conveys
                      to Spectra all of Customer’s right, title and interest
                      (including all intellectual property rights) in and to
                      such Service Data. Spectra will be entitled to make
                      Service Data available to third parties in Spectra’s
                      discretion if such Service Data does not identify Customer
                      and cannot be traced back to Customer. For greater
                      certainty, Spectra shall own all right, title and interest
                      (including all intellectual property rights) in and to any
                      analytics created therefrom and shall be entitled to use
                      the said analytics without any requirement for Customer’s
                      permission provided that the analytics do not identify
                      Customer and cannot be traced back to Customer.
                    </p>
                  </div>
                  <div id='limitations-of-liability'>
                    <h3>6. Limitations of Liability</h3>
                    <p>
                      The Software is provided "as is," without warranty of any
                      kind, express or implied, including but not limited to
                      warranties of performance, merchantability, fitness for a
                      particular purpose, and non-infringement. Neither Spectra
                      nor its licensors, resellers, dealers or suppliers shall
                      have any liability to customer or any other person or
                      entity for any indirect, incidental, special,
                      consequential or any other similar damages whatsoever,
                      including, but not limited to, loss of revenue or profit,
                      lost or damaged data or other commercial or economic loss,
                      even if Spectra has been advised of the possibility of
                      such damages, or they are foreseeable. Spectra is also not
                      responsible for claims by a third party. The product(s)
                      are not fault-tolerant and are not designed, manufactured,
                      or intended for use or resale as products for use in
                      hazardous environments requiring fail-safe performance in
                      which the failure of the product(s) could lead directly to
                      death, personal injury, or severe physical or
                      environmental damage. Spectra’s maximum aggregate
                      liability to customer, and that of Spectra’s licensors,
                      dealers, resellers and suppliers shall not exceed the
                      price paid for the product(s) giving rise to the claim.
                      The limitations in this section shall apply whether or not
                      the alleged breach or default is a breach of a fundamental
                      condition or term or a fundamental breach.
                    </p>
                  </div>
                  <div id='termination'>
                    <h3>7. Termination</h3>
                    <p>
                      This Agreement is effective until terminated. The Licensor
                      may terminate the license if the Licensee breaches any
                      terms. Upon termination, the Licensee must cease all use
                      and delete all copies of the Software.
                    </p>
                  </div>
                  <div id='export-control'>
                    <h3>8. Export Control</h3>
                    <p>
                      Licensee agrees to comply with all applicable export laws
                      and regulations of Canada and the United States. The
                      Software may not be exported or re-exported to embargoed
                      countries or unauthorized users.
                    </p>
                  </div>
                  <div id='governing-law'>
                    <h3>9. Governing Law</h3>
                    <p>
                      This Agreement shall be governed by the laws of the
                      Province of Ontario, Canada and the laws of Canada
                      applicable therein.
                    </p>
                  </div>
                  <div id='acceptance'>
                    <h3>10. Acceptance</h3>
                    <p>
                      By installing or using the Software, the Licensee
                      acknowledges and agrees to be bound by the terms of this
                      Agreement.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Terms;
